/* eslint-disable react/no-unstable-nested-components */
import useChangeSetting from "components/settings/hooks/useChangeSetting";
import classNames from "components/ui/classNames";
import { MoonIcon, SunIcon } from "lucide-react";
import { parseAsStringLiteral, useQueryState } from "nuqs";

import type { HTMLAttributes } from "react";

interface DarkModeButtonV2Props extends HTMLAttributes<HTMLButtonElement> {
  persistency?: "queryString" | "userSettings";
}

export default function DarkModeButtonV2({ persistency = "userSettings", ...props }: DarkModeButtonV2Props) {
  const { value: currentThemeFromSettings, set: setThemeSetting } = useChangeSetting("theme", "LIGHT");
  const [currentThemeFromUrl, setThemeViaUrl] = useQueryState(
    "theme",
    parseAsStringLiteral(["light", "dark"]).withDefault("light"),
  );

  const currentThemeOption = persistency === "userSettings" ? currentThemeFromSettings : currentThemeFromUrl;
  const theme = currentThemeOption?.toLowerCase() as "dark" | "light";

  return (
    <button
      {...props}
      disabled={false}
      type="button"
      onClick={() => {
        if (persistency === "userSettings") {
          const nextTheme = currentThemeFromSettings === "DARK" ? "LIGHT" : "DARK";
          setThemeSetting(nextTheme);
        }
        if (persistency === "queryString") {
          const nextTheme = currentThemeFromUrl === "dark" ? "light" : "dark";
          setThemeViaUrl(nextTheme === "light" ? null : nextTheme);
        }
      }}
      className={classNames(
        "flex size-10 items-center justify-center rounded-full",
        "bg-gray-100 text-gray-600 dark:bg-slate-700 dark:text-slate-300",
        "border border-slate-300 hover:bg-gray-200 hover:text-gray-900 dark:border-slate-600 hover:dark:text-yellow-300",
        "outline-none",
        "focus-visible:bg-indigo-50 focus-visible:ring-2 focus-visible:ring-indigo-100 focus-visible:ring-offset-1 focus-visible:ring-offset-indigo-300",
        "dark:hover:ring-slate-500 dark:hover:ring-offset-slate-500",
      )}
    >
      {theme === "dark" ? <SunIcon strokeWidth={2} /> : <MoonIcon strokeWidth={2} />}
    </button>
  );
}
